module.exports = __webpack_public_path__ + "img/01.9f24bc69.png";